function initSortWidget() {
  const body   = document.querySelector('body') as HTMLElement;
  const widget = document.getElementById('news-sort-widget');


  if (!widget) return;

  widget.addEventListener('click', (event: MouseEvent) => {
    widget.classList.toggle('widget-closed');
    event.stopPropagation();
  }, false);

  body.addEventListener('click', () => {
    widget.classList.add('widget-closed');
  });
}

initSortWidget();